import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useTourStore } from '@eliadmin/core/src/stores/tours-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';
import { TourSidebarFilterLabel } from '../tour-sidebar-filter-label';
import { MultiSelectAsync } from '../../../ui/multi-select-async';
import { useTourOptions } from '../../../../hooks/use-tour-options';

export const TourSidebarFilterTours = ({ noLabel = false }: { noLabel?: boolean }) => {
  const { filter, setFilter } = useTourStore();
  const { t } = useTranslations();

  const tourOptions = useTourOptions();

  // 2) Build the current selected value from your store + local label
  const currentValue = filter.tour
    ? {
        value: filter.tour.toString(),
        label: filter.tourName, // or retrieve from store if you prefer
      }
    : null;

  return (
    <div className="text-sm font-semibold">
      {/* Optional label */}
      {!noLabel && <TourSidebarFilterLabel label={t('text1850')} />}

      <MultiSelectAsync
        // Async loading
        {...tourOptions}
        isMulti={false} // Single select
        placeholder={t('text1836')}
        aria-label={t('text1836')}
        // Controlled input: use your store's filter + local label
        value={currentValue}
        onChange={selectedOption => {
          setFilter({ tourName: selectedOption ? selectedOption.label : '' });
          setFilter({ tour: selectedOption ? selectedOption.value : undefined });
        }}
        // Optionally disable
        // If no options found
        noOptionsMessage={() => t('text477')}
        isSearchable
        menuPlacement="bottom"
        // Copy the same styling / class config from your original MultiSelect usage
        stylesConfig={{}}
        classNamesConfig={{
          container: () => cn('border-none'),
          valueContainer: () =>
            cn('cursor-pointer pl-1 rounded-lg bg-white text-sm font-medium border-none'),
          placeholder: () => cn('text-muted-foreground text-sm font-medium'),
          control: () => cn('rounded-lg h-full bg-white'),
          menu: () => cn('rounded-lg !z-[100000] hide-scroll-bar'),
          menuList: () =>
            cn('hide-scroll-bar !left-[-40px] !top-1 border-none !z-[10000] !bg-white block'),
          indicatorsContainer: () => cn('!hidden'),
        }}
        // "before" icon for search
        before={<FiSearch className="ml-4 h-6 w-6 cursor-default text-primary" />}
        variant="outlined"
      />
    </div>
  );
};
